import { useEffect, useRef, useState } from 'react'

import { FormModal } from '../../components/FormModal'
import { MoneyInput } from '../../components/MaskedInput'
import { useAppToast } from '../../helpers'
import { EventService } from '../../services/Event/EventService'

export default function ParkingEditModal({
  isOpen,
  onClose,
  value,
  eventId,
  onSaved
}: {
  isOpen: boolean
  onClose: () => void
  value: number | null
  eventId: number | undefined
  onSaved: (newValue: number) => void
}) {
  const toast = useAppToast()
  const [inputValue, setInputValue] = useState<number | null>(null)
  const [isSaving, setIsSaving] = useState(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const eventService = new EventService()

  useEffect(() => {
    if (isOpen) {
      setInputValue(value)
      setTimeout(() => inputRef.current?.focus(), 100)
    }
  }, [isOpen, value])

  async function handleSave() {
    if (!eventId) return
    setIsSaving(true)
    try {
      const res = await eventService.updateParkingRevenue(eventId, inputValue ?? 0)
      onSaved(Number(res.parking_revenue) || 0)
      onClose()
    } catch {
      toast.error('Erro ao salvar')
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      title="Receita de estacionamento"
      onSubmit={handleSave}
      size="compact"
      isLoading={isSaving}
    >
      <MoneyInput ref={inputRef} value={inputValue} onChange={setInputValue} />
    </FormModal>
  )
}
